import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { NadzornaPlocaService } from './nadzorna-ploca.service';

@Component({
  templateUrl: 'nadzorna-ploca.component.html',
  styleUrls: ['./nadzorna-ploca.component.scss'],
  providers: [NadzornaPlocaService],
})
export class NadzornaPlocaComponent implements OnInit {
  tablica: any;
  smjene: any;
  linije: any;
  d = '';
  s = '';
  l = '';
  poruka: any;
  today: Date = new Date();
  rnData: any;
  rnPopup: boolean = false;
  datumRN: string = moment().format('YYYY-MM-DD');
  napomenaRN: string = '';
  userRN: string;
  skladisteSirovina: string;
  skladisteGotovih: string;
  rn: any;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private service: NadzornaPlocaService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }
    this.smjene = [
      { id: '', naziv: 'SVE' },
      { id: 1, naziv: '1' },
      { id: 2, naziv: '2' },
      { id: 3, naziv: '3' },
    ];
    this.linije = [{ id: '', naziv: 'SVE' }];
    this.userRN = localStorage.getItem('iduser');

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().nadzornaPloca;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiSveLinije();
    this.d = moment(this.today).format('YYYY-MM-DD');
    this.nadzornaPloca(this.d, this.s, this.l);
  }

  nadzornaPloca(d, s, l) {
    let objekt = {
      datum: d,
      smjena: s,
      brojlinije: l,
    };
    // console.log(objekt);
    this.tablica = [];
    this.service.nadzornaPloca(objekt).subscribe((res) => {
      // console.log(res);
      if (res.data.length == 0) {
        this.poruka = 'Nema podataka!';
      } else {
        this.poruka = 'Učitavanje...';
      }
      for (let data of res.data) {
        this.tablica.push({
          brojNaloga: data.nl_broj,
          lot: data.ar_lot,
          idArtikl: data.ar_id,
          sifra: data.ar_sifra,
          naziv: data.ar_naziv,
          trebaNapraviti: data.rns_napraviti,
          ispeceno: data.rns_ispecenoukupno,
          spakirano: data.rns_zamrznutoukupno,
          vrijemePocetka:
            moment(data.nl_datumpocetka).format('DD.MM.YYYY.') +
            ' ' +
            data.nl_vrijemepocetka,
          statusRN: data.nl_status,
          smjena: data.smjena_idsmjena,
          linija: data.li_naziv,
          idPlan: data.idplanproizvodnje,
          idSkladista: data.poslovnica_idposlovnica,
          cijenaStruja: data.li_cijenaKW,
          cijenaPlin: data.li_cijenaplina,
          cijenaVoda: data.li_cijenavode,
          cijenaOTP: data.li_otkKN,
          napomena: data.pp_napomena,
          skladisteSirovina: data.po_naziv,
          skladisteGotovih: data.nazivgotovo,
          posifra: data.po_sifra,
          posifragotovo: data.posifragotovo,
          kolicina: data.pp_planiranakolicina,
        });
      }
    });
  }

  onCellPrepared(options) {
    // console.log(options);
    if (options.rowType == 'data') {
      if (options.column.dataField === "statusRN"){
        if (options.value == 'L') {
          options.cellElement.classList.add('circleYellow');
        }
        if (options.value == 'O') {
          options.cellElement.classList.add('circleRed');
        }
        if (options.value == 'Z') {
          options.cellElement.classList.add('circleGreen');
        }
      }
    
      if (options.column.dataField === "smjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
    // if (options.rowType == "data" && (options.columnIndex == 9 || options.columnIndex == 10)) {
    //   options.cellElement.classList.add("size-26");
    // }
  }

  promjenaDatuma(e) {
    // console.log(e);
    this.d = moment(e.value).format('YYYY-MM-DD');
    this.nadzornaPloca(this.d, this.s, this.l);
  }

  promjenaSmjene(e) {
    // console.log(e);
    this.s = e.value;
    this.nadzornaPloca(this.d, this.s, this.l);
  }

  promjenaLinije(e) {
    // console.log(e);
    this.l = e.value;
    this.nadzornaPloca(this.d, this.s, this.l);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift(
      {
        location: 'before',
        template: 'naslovTablice',
      },
      {
        location: 'after',
        template: 'odabirDatuma',
      },
      {
        location: 'after',
        template: 'odabirSmjene',
      },
      {
        location: 'after',
        template: 'odabirLinije',
      }
    );
  }

  // DOHVAĆANJE NAZIVA LINIJA
  dohvatiSveLinije() {
    this.service.dohvatiSveLinije({}).subscribe((res) => {
      // console.log(res);
      this.linije = [{ id: '', naziv: 'SVE' }];
      if (res.success == true) {
        for (let linija of res.data) {
          // console.log(linija);
          this.linije.push({
            id: linija.idlinija,
            naziv: linija.li_naziv,
          });
        }
        // console.log(this.linije);
      }
    });
  }

  onPlanskaKalkulacija(data) {
    // console.log(data);
    let idPlan = data.data.idPlan;
    // console.log(idPlan);
    const podaci = {
      idplanproizvodnje: data.data.idPlan,
      cijenaKW: data.data.cijenaStruja,
      cijenaplina: data.data.cijenaPlin,
      cijenavode: data.data.cijenaVoda,
      cijenaotp: data.data.cijenaOTP,
      idartikl: data.data.idArtikl,
      idfirma: parseInt(localStorage.getItem('firma')),
      idposlovnica: data.data.idSkladista,
      artiklsifra: data.data.sifra,
    };
    // console.log(podaci);
    this.service.obracunPlanske(podaci).subscribe((res) => {
      // console.log(res);
      if (res.success == true) {
        this.router.navigate(['/planska-kalkulacija/' + idPlan]);
      }
    });
  }

  promjenaDatumaRN(e) {
    // console.log(e);
    this.datumRN = moment(e.value).format('YYYY-MM-DD');
  }
  promjenaNapomenaRN(e) {
    this.napomenaRN = e.value;
  }

  popupKreirajRN(data) {
    // console.log(data);
    this.rnPopup = true;
    this.skladisteSirovina = data.data.skladisteSirovina;
    this.skladisteGotovih = data.data.skladisteGotovih;
    this.napomenaRN = data.data.napomena;
    this.rn = {
      login: this.userRN,
      posifra: data.data.posifra,
      posifragotovo: data.data.posifragotovo,
      idplanproizvodnje: data.data.idPlan,
      idartikl: data.data.idArtikl,
      kolicina: data.data.kolicina,
    };
  }

  kreirajRN() {
    const radniNalog = {
      datum: this.datumRN,
      napomena: this.napomenaRN,
      ...this.rn,
    };
    // console.log(radniNalog);
    /* privremeno iskljuceno 03.05.'23 */
    /*
    this.service.kreirajRN(radniNalog).subscribe((res) => {
      console.log(res);
      this.rnPopup = false;
      this.nadzornaPloca(this.d, this.s, this.l);
      notify('Uspješno kreiranje radnog naloga.', 'success', 3000);
    });
    */
  }
}
